import {
    PageTemplates,
    isPageTemplate,
} from "@utils/configuration/pageTemplate.helpers";

import {
    StepVariables,
    ToolContext,
} from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";
import { hasWindow } from "@utils/general";

type StepTypes = "start" | "submit";

const isCheckoutPage = () =>
    hasWindow() && isPageTemplate(PageTemplates.CHECKOUT);

const placement = isCheckoutPage() ? "bestellen:login" : "klantgegevens:login";

const TOOL_LOGIN_STEPS: Record<StepTypes, StepVariables> = {
    start: {
        stepName: "Bestaande klanten",
        stepNumber: 1,
        placement: placement,
        result: {},
        option: "",
    },
    submit: {
        stepName: "succesvol ingelogd",
        stepNumber: 2,
        placement: placement,
        result: {},
        option: "",
    },
};

const TOOL_LOGIN_CONTEXT: Readonly<ToolContext> = {
    name: "login",
    type: "form",
};

export { TOOL_LOGIN_STEPS, TOOL_LOGIN_CONTEXT };
